import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-145d53ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-placeholder col-12" }, null, -1))
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "text-light col-12 fex-centered py-4 py-sm-5 detailed-footer" }
const _hoisted_4 = { class: "container-lg d-flex flex-column flex-md-row align-items-center align-items-md-start justify-content-between py-2 flex-wrap" }
const _hoisted_5 = { class: "text-center text-lg-start mb-4 quick-links col-12 col-md-6 col-lg-auto order-md-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h6" }, "Quick Links", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "d-block mb-4",
  target: "_blank",
  href: "https://www.tevo.co.za/all/outdoor/portable-power-stations"
}, "Shop Online", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h6" }, "Contact Us", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "d-block",
  href: "mailto:info@tevo.co.za"
}, "info@tevo.co.za", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center text-lg-start mb-4 mt-md-4 mt-lg-0 address col-12 col-md-6 col-lg-auto order-md-3 order-lg-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "h6" }, "Address"),
  /*#__PURE__*/_createElementVNode("p", null, "Office 3 Rydallviews"),
  /*#__PURE__*/_createElementVNode("p", null, "5A Rydall Vale Office Park"),
  /*#__PURE__*/_createElementVNode("p", null, "38 Ridge Douglas Saunders Dr"),
  /*#__PURE__*/_createElementVNode("p", null, "La Lucia Ridge, 4051"),
  /*#__PURE__*/_createElementVNode("p", null, "KwaZulu Natal, South Africa")
], -1))
const _hoisted_11 = { class: "text-center text-lg-start mb-1 mb-md-4 mb-lg-0 products col-12 col-md-6 col-lg-auto order-md-2 order-lg-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h6" }, "Product Range", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "d-block d-md-none d-lg-block h6 mt-4 mb-4 mb-lg-0",
  target: "_blank",
  href: "https://www.tevo.co.za/warranty"
}, "Register your warranty", -1))
const _hoisted_14 = { class: "col-12 col-md-6 col-lg-auto order-md-4 text-center text-lg-start" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "d-none d-md-block d-lg-none h6 mb-4",
  target: "_blank",
  href: "https://www.tevo.co.za/warranty"
}, "Register your warranty", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Magneto logo",
  class: "img-fluid w-100"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"text-center text-lg-start\" data-v-145d53ba><p class=\"mt-4 mt-lg-5\" data-v-145d53ba>Follow us:</p><a href=\"https://www.facebook.com/TevoPtyLtd/\" target=\"_blank\" class=\"fa-stack social-icons fa-2x\" data-v-145d53ba><i class=\"fa-solid fa-square fa-stack-2x fa-inverse\" data-v-145d53ba></i><i class=\"fa-brands fa-facebook-f fa-stack-1x\" data-v-145d53ba></i></a><a href=\"https://www.instagram.com/tevo_sa/\" target=\"_blank\" class=\"fa-stack social-icons fa-2x\" data-v-145d53ba><i class=\"fa-solid fa-square fa-stack-2x fa-inverse\" data-v-145d53ba></i><i class=\"fa-brands fa-instagram fa-stack-1x\" data-v-145d53ba></i></a></div>", 1)
const _hoisted_18 = { class: "bg-black text-light col-12 fex-centered py-4 misc-footer" }
const _hoisted_19 = { class: "container-lg d-flex flex-column flex-md-row align-items-center justify-content-between" }
const _hoisted_20 = { class: "mb-0 copyright" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_router_link, {
              to: { name: 'AboutUs' },
              class: "d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("About Us")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: { name: 'ContactUs' },
              class: "d-block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Contact Us")
              ]),
              _: 1
            }),
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_router_link, {
              class: "d-block",
              to: {name: 'ProductRange'}
            }, {
              default: _withCtx(() => [
                _createTextVNode("300W Portable Power Station")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "d-block",
              to: {name: 'ProductRange'}
            }, {
              default: _withCtx(() => [
                _createTextVNode("600W Portable Power Station")
              ]),
              _: 1
            }),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_router_link, {
              class: "navbar-brand",
              to: {name: 'Home'}
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }),
            _hoisted_17
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", _hoisted_20, "© " + _toDisplayString(new Date().getFullYear()) + " Magneto", 1)
        ])
      ])
    ])
  ], 64))
}